import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { dbObject, finance } from "../data";
import { createButton } from "./createButton";
import { onLog } from "firebase/app";

export const collisionEasy = (
  scene,
  pause,
  isColliding,
  frozen,
  clickable,
  stone1,
  stone2,
  character,
  width,
  height,
  scaleX
) => {
  if (!isColliding) {
    stone1.setVelocityX(0);
    stone2.setVelocityX(0);
    character.setVelocityX(0);
    character.setVelocityY(0);
    character.setGravityY(0);
    frozen = true;
    clickable = false;
    finance.freePlay--;
    if (!finance.skinned) {
      character.play({ key: "dizzy" });
    } else {
      character.play({ key: "skinnedDizzy" });
    }
    loseMenu(scene, pause, scaleX, width, height);
    isColliding = true;
  }
  return [isColliding, frozen, clickable];
};

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Group} obstacles
 * @param {Phaser.GameObjects.Image} pause
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const collisionMedium = (
  scene,
  obstacles,
  pause,
  character,
  scaleX,
  width,
  height
) => {
  obstacles.setVelocityX(0);
  if (!finance.skinned) {
    character.play({ key: "dizzy" });
  } else {
    character.play({ key: "skinnedDizzy" });
  }

  character.setVelocityX(0).setVelocityY(0).setGravityY(0);
  loseMenu(scene, pause, scaleX, width, height);
};

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Group} obstacles
 * @param {Phaser.Physics.Arcade.Sprite} line
 * @param {Phaser.Physics.Arcade.Sprite} character
 * @param {Phaser.GameObjects.Image} pause
 */
export const overlap = (
  scene,
  obstacles,
  line,
  character,
  pause,
  scaleX,
  width,
  height
) => {
  obstacles.setVelocityX(0);
  character.setDepth(2);
  line.destroy();
  character.body.setVelocityY(1000 * scaleX);
  character.setVelocityX(450 * scaleX);
  loseMenu(scene, pause, scaleX, width, height);
};

/**
 *
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const inPit = (character, height, scaleX) => {
  if (character.getBounds().bottom > height + 100 * scaleX) {
    if (!finance.skinned) {
      character.play({ key: "dizzy" });
    } else {
      character.play({ key: "skinnedDizzy" });
    }
    character.setVelocityY(0).setVelocityX(0).setGravityY(0);
    let atPitBottom = true;
    return atPitBottom;
  }
};

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.GameObjects.Image} pause
 */
const loseMenu = (scene, pause, scaleX, width, height) => {
  scene.sound.play("lose");
  if (finance.freePlay > 0) {
    pause.setVisible(false);
    scene.add
      .image(width / 2, height / 2, "bambooFrame")
      .setScale(0.7 * scaleX, 0.7 * scaleX);
    scene.add
      .text(width / 2, 200 * scaleX, "Un-lucky!", {
        fontFamily: "Grooving",
        fontSize: "70px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5);
    scene.add
      .text(width / 2 - 70 * scaleX, 270 * scaleX, "Open the loot", {
        fontFamily: "Grooving",
        fontSize: "30px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5);
    scene.add
      .text(width / 2 - 70 * scaleX, 300 * scaleX, "Crate for 50 coins?", {
        fontFamily: "Grooving",
        fontSize: "30px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5);
    scene.add
      .text(width / 2 - 70 * scaleX, 345 * scaleX, "Or", {
        fontFamily: "Grooving",
        fontSize: "30px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5);
    scene.chest
      .setPosition(width / 2 + 70 * scaleX, 300 * scaleX)
      .setDepth(1)
      .setVisible(true);
    scene.add
      .text(width / 2 - 90 * scaleX, 400 * scaleX, "Restart Level", {
        fontFamily: "Grooving",
        fontSize: "40px",
        color: "#323232",
      })
      .setScale(scaleX)
      .setOrigin(0.5);
    createButton(
      scene,
      width / 2 + 120 * scaleX,
      400 * scaleX,
      "restart",
      0.3 * scaleX,
      () => {
        scene.scene.restart();
      }
    );
  } else {
    scene.time.delayedCall(1000, async () => {
      onLog((e) => {
        if (e.level === "warn") {
          window.alert("Internet Connection has been lost");
        }
      });
      try {
        switch (finance.level) {
          case 1:
            dbObject.progress = "level1";
            break;
          case 2:
            dbObject.progress = "level2";
            break;
          case 3:
            dbObject.progress = "level3";
            break;
          default:
            dbObject.progress = "level1";
            break;
        }
        dbObject.timeEnded = Timestamp.now();
        dbObject.timePlayedInSec = Math.round(
          dbObject.timeEnded - dbObject.timeStarted
        );
        await addDoc(collection(db, "allPlayers"), dbObject);
      } catch (error) {
        console.log(error.message);
      }
      scene.scene.start("start");
    });
  }
};
